import { Component, OnInit } from '@angular/core';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  HttpService,
  IButtonlabelEdit,
  MenuBreadCrumb,
  MessageService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { TravelRoute } from '../../../../models2/localization/travel-route';
import { Checkpoint } from '../../../../models2/localization/checkpoint';
import { GeolocationService } from 'app/services/geolocation.service';
import { TravelHistory } from 'app/models2/localization/travel-history';
import { CheckpointHistory } from 'app/models2/localization/checkpoint-history';
import { Router } from '@angular/router';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { Equipment } from 'app/models2/maintenance/equipment';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { PushNotificationsService } from 'app/services/push-notifications.service';
import { UserToken } from 'app/models2/administration/user-token';
import { MatDialog } from '@angular/material/dialog';
import { ModalTypesComponent } from 'app/components/shared/modals-types/modal-types.component';
import { UploadService } from 'app/services/upload.service';
import { CheckpointService } from 'app/services/checkpoint.service';

@Component({
  selector: 'app-handler-router',
  templateUrl: './handler-router.component.html',
  styleUrls: ['./handler-router.component.scss'],
})
export class HandlerRouterComponent implements OnInit {
  urlGetRoutes: string = `${EndpointDictionary.TravelRoute.TRAVEL_ROUTER_TABLE}`;
  urlTravelHistory: string = `${EndpointDictionary.Travelhistory.CRUD_TRAVEL_HISTORY}`;
  urlAddPointerTravelHistory: string = `${EndpointDictionary.Travelhistory.ADD_POINTER_TRAVEL_HISTORY}`;
  urlCloseTravelHistory: string = `${EndpointDictionary.Travelhistory.CLOSE_TRAVEL_HISTORY}`;
  urLValidateHasTravelActive: string = `${EndpointDictionary.Travelhistory.HAS_TRAVEL_ACTIVE}`;
  private urlCrudUserToken: string = `${EndpointDictionary.User.USER_TOKEN}`;

  colorComplete: string = '#99aabd';
  colorIncomplete: string = '#d18888';
  colorPending: string = '#36858a94';
  controlPointer: Checkpoint[] = [];
  hasTravelActive = false;
  equipmentSelect = false;
  equipment: Equipment;
  travelRoute: TravelRoute;
  travelHistory: TravelHistory;
  labelsRouter: IButtonlabelEdit[] = [];
  labelsTravelHistory: IButtonlabelEdit[] = [{ value: '' }, { value: '' }];

  routeColumnsTable: TableColumns<TravelRoute>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'originName',
      label: 'Origen',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'endName',
      label: 'Destino',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
  ];
  routeConfigurationTable: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };

  menuBreadCrumb: MenuBreadCrumb[] = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Iniciar ruta',
      current: true,
    },
  ];

  constructor(
    private http: HttpService,
    private message: MessageService,
    private geolocationService: GeolocationService,
    private router: Router,
    private deleteItem: DeleteGenericService,
    private dialog: MatDialog,
    private uploadService: UploadService,
    private checkpointService: CheckpointService
  ) {}

  async ngOnInit() {
    await this.validateHasTravelActive();
  }

  clickRowEquipment($event: Equipment) {
    this.equipmentSelect = true;
    this.equipment = $event;
    this.labelsTravelHistory[0] = {
      label: 'Equipo: ',
      value: this.equipment.code.toUpperCase(),
      edit: false,
    };
  }

  async clickRowRoute($event: TravelRoute) {
    this.message.openLoading('Cagando', 'Obteniendo ruta');

    this.setLabelRoute($event.name);

    let res = await this.http.getDataBody<TravelRoute[]>(
      `${EndpointDictionary.TravelRoute.CRUD_TRAVEL_ROUTER}/${$event.id}`
    );
    if (res && res[0]) {
      this.travelRoute = res[0];
      this.controlPointer = this.travelRoute.checkpoints;
      this.controlPointer.map((x) => (x.buttonsType = [1]));
    }
    this.message.closeLoading();
  }

  initRoute() {
    try {
      if (!this.travelRoute) {
        this.message.ErrorToast('Seleccione una ruta');
        console.log('No hay ruta seleccionada');
        return;
      }

      this.geolocationService.getPositionResult((pos) => {
        // this.pushNotificationsService.getNotificationToken(async (token) => {
        //   if (token) {
        //     let body: UserToken = {
        //       token: token,
        //       type: 2,
        //     };
        //     console.log('Current token:', token);
        //     await this.http.postDataBody(this.urlCrudUserToken, body);
        //   }
        // });

        this.message.SuccessToast('Iniciando viaje');
        this.addHistoryTravel(pos);
      });
    } catch (error) {
      console.log('error localizacion', error);
    }
  }

  // para la aplicación nativa
  // async initRoute(addHistoryTravel: boolean = true) {
  //   console.log('Iniciando viaje...', this.travelRoute);
  //   try{

  //   if (!this.travelRoute) {
  //     this.message.ErrorToast("Seleccione una ruta")
  //     console.log('No hay ruta seleccionada');
  //     return
  //   }

  //   this.geolocationService.getPositionResultWithCapacitor(pos => {
  //     this.pushNotificationsService.getNotificationToken(async token => {
  //       if (token) {
  //         let body: UserToken = {
  //           token: token,
  //           type: 2
  //         }
  //         console.log('Current token:', token);
  //         await this.http.postDataBody(this.urlCrudUserToken, body);
  //       }
  //       if(addHistoryTravel) await this.addHistoryTravel(pos);
  //       this.pushNotificationsService.listenNotificacions()
  //       this.message.SuccessToast("Iniciando viaje")
  //     })

  //   });
  // }catch(error){
  //   console.log('error localizacion',error)}
  // }

  async cancelTravel() {
    let deleteTravel = await this.message.Warning(
      'Advertencia',
      'Si cancela el viaje, se borrará cualquier registro que lleve. ¿Desea eliminar el viaje?',
      true,
      'Sí',
      'No'
    );
    if (deleteTravel) {
      let res = await this.deleteItem.deleteWhitoutWarning(
        this.urlTravelHistory,
        this.travelHistory.id
      );
      if (res) {
        this.message.SuccessToast('Viaje eliminado exitosamente');
        this.router.navigate(['inicio']);
      }
    }
  }

  async openAddCheckpointDialog($event?: Checkpoint) {
    this.message.openLoading('Cargando', 'Registro punto de control');
    if (!$event.complete) {
      let message = $event.name
        ? `¿Desea registrar el punto de control ${$event.name}?`
        : '¿Desea registrar un punto de control intermedio?';
      let validateCP = await this.validateControlPointersComplete($event.index);

      if (!validateCP && $event.id != -2) {
        message = `Hay puntos de control que no se han registrado, ${message}`;
      }

      if ($event.id == -2) {
        message = `¿Desea finalizar el viaje?`;
      }

      let saveControlPointer = await this.message.Warning(
        'Advertencia',
        message,
        true,
        'Sí',
        'No'
      );

      if (!saveControlPointer) {
        this.message.closeLoading();
        return;
      }
    }

    let size: number = screen.width > 500 ? 60 : 50;
    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: {
        name: 'punto de control',
        body: $event,
      },
    });

    dialogRef.afterClosed().subscribe(async (checkpointData: Checkpoint) => {
      this.message.openLoading('Cargando', 'Registro punto de control');
      if (checkpointData) {
        let photo = await this.uploadService.uploadFile(checkpointData.photo);
        if (checkpointData.name) {
          checkpointData.photo = photo;
          checkpointData.index = $event.index + 1;
          await this.addIntermediateCheckpoint(checkpointData);
        } else {
          Object.assign(this.controlPointer[$event.index], {
            description: checkpointData.description,
            photo: photo,
          });
          await this.addLocalization(this.controlPointer[$event.index]);
        }
      }
      this.message.closeLoading();
    });
    this.message.closeLoading();
  }

  private async validateHasTravelActive() {
    this.message.openLoading('Cargando', 'Validando ruta actual');
    let res = await this.http.getDataBody<TravelHistory>(
      this.urLValidateHasTravelActive
    );
    if (res && res.id) {
      this.hasTravelActive = true;
      this.travelHistory = res;

      this.clickRowEquipment({
        id: res.equipmentId,
        code: res.code,
      });

      this.controlPointer = res.checkpoints;
      this.controlPointer.map((x) => (x.buttonsType = [1]));

      this.controlPointer.forEach((pointer, index) => {
        if (pointer.complete) {
          this.validateControlPointersComplete(index, true);
          this.closeControlPointer(index);
        }
      });
      this.setLabelRoute(res.routeName);
    } else {
      this.hasTravelActive = false;
    }
    this.message.closeLoading();
  }

  private async addHistoryTravel(pos: GeolocationPosition) {
    this.message.openLoading('Cargando', 'Iniciando viaje');

    this.travelHistory = {
      equipmentId: this.equipment.id,
      routeId: this.travelRoute.id,
      checkpoints: [
        {
          name: this.controlPointer[0].name,
          longitude: pos.coords.longitude,
          latitude: pos.coords.latitude,
        },
      ],
    };
    var res = await this.http.postDataBody<GenericResponse>(
      this.urlTravelHistory,
      this.travelHistory
    );
    if (res) {
      this.travelHistory.id = res.insertId;
      this.menuBreadCrumb[1].name = 'Viaje en curso';
      this.closeControlPointer(0);
      this.hasTravelActive = true;
    }

    this.message.closeLoading();
  }

  private async addIntermediateCheckpoint(checkpointData: Checkpoint) {
    this.geolocationService.getPositionResult(async (pos) => {
      this.message.openLoading('Cargando', 'Agregando punto de control');
      const checkpoint: CheckpointHistory = {
        travelHistoryId: this.travelHistory.id,
        checkpoints: [
          {
            name: checkpointData.name,
            description: checkpointData.description,
            photo: checkpointData.photo,
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            complete: true,
            position: checkpointData.index,
            additionalCheckpoint: 1,
            background: this.colorComplete,
          },
        ],
      };

      const res = await this.http.postDataBody<GenericResponse>(
        this.urlAddPointerTravelHistory,
        checkpoint
      );

      if (res) {
        this.message.SuccessToast('Punto de control agregado exitosamente');
        this.controlPointer.splice(checkpointData.index, 0, {
          ...checkpoint.checkpoints[0],
          id: res[0].id,
          complete: true,
          buttonsType: [4],
        });

        for (
          let i = checkpointData.index + 1;
          i < this.controlPointer.length;
          i++
        ) {
          this.controlPointer[i].position = i;
        }
      }
      await this.validateAndAssignButtonType(checkpointData.index);
      this.message.closeLoading();
    });
  }

  private async addLocalization($event: Checkpoint) {
    if ($event.id == -2) {
      this.geolocationService.getPositionResult(async (pos) => {
        this.message.openLoading('Cargando', 'Finalizando viaje');
        $event.latitude = pos.coords.latitude;
        $event.longitude = pos.coords.longitude;

        let body: TravelHistory = {
          id: this.travelHistory.id,
          checkpoints: [$event],
        };
        let res = await this.http.postDataBody(
          this.urlCloseTravelHistory,
          body
        );
        if (res) {
          await this.validateAndAssignButtonType($event.index);
          this.message.SuccessToast('Viaje almacenado exitosamente');
          this.router.navigate(['inicio']);
        }
        this.message.closeLoading();
      });
      return;
    }

    this.geolocationService.getPositionResult(async (pos) => {
      await this.addControlPointerToHistory($event, pos);
    });
  }

  private async addControlPointerIncompleteToHistory(index: number) {
    this.message.openLoading('Cargando', 'Registrando punto de control');
    this.controlPointer[index].registered = 0;
    this.controlPointer[index].complete = true;
    this.controlPointer[index].buttonsType = [4];
    this.controlPointer[index].latitude = null;
    this.controlPointer[index].longitude = null;
    this.controlPointer[index].background = this.colorIncomplete;

    let incompleteBody: TravelHistory = {
      id: this.travelHistory.id,
      checkpoints: [this.controlPointer[index]],
    };

    let res = await this.http.postDataBody(
      this.urlAddPointerTravelHistory,
      incompleteBody
    );

    if (res) this.controlPointer[index].id = res[0].id;

    this.message.closeLoading();
  }

  private async addControlPointerToHistory(
    $event: Checkpoint,
    pos: GeolocationPosition
  ) {
    this.message.openLoading('Cargando', 'Registrando puntos de control');
    $event.latitude = pos.coords.latitude;
    $event.longitude = pos.coords.longitude;

    let body: CheckpointHistory = {
      travelHistoryId: this.travelHistory.id,
      checkpoints: [$event],
    };
    let res = await this.http.postDataBody(
      this.urlAddPointerTravelHistory,
      body
    );
    if (res) {
      this.controlPointer[$event.index].id = res[0].id;
      this.closeControlPointer($event.index);
      await this.validateAndAssignButtonType($event.index);
    }
    this.message.closeLoading();
  }

  private async validateControlPointersComplete(
    start: number,
    closeControlPointer = false,
    addControlPointerIncomplete = false
  ): Promise<boolean> {
    const reversedPointers = this.controlPointer.slice(0, start).reverse();
    let validate = true;
    for (const pointer of reversedPointers) {
      if (closeControlPointer && !pointer.complete) {
        const index = this.controlPointer.findIndex((x) => x === pointer);
        this.closeControlPointer(index);
      }
      if (addControlPointerIncomplete && !pointer.complete) {
        const index = this.controlPointer.findIndex((x) => x === pointer);
        await this.addControlPointerIncompleteToHistory(index);
      }
      if (!pointer.complete) {
        validate = false;
      }
    }
    return validate;
  }

  private closeControlPointer(index: number) {
    if (this.controlPointer[index].registered === 0) {
      this.controlPointer[index].background = this.colorIncomplete;
    } else {
      this.controlPointer[index].background = this.colorComplete;
    }
    this.controlPointer[index].complete = true;
    this.controlPointer[index].buttonsType = [4];
  }

  private setLabelRoute(routeName: string) {
    let label = {
      label: 'Viaje: ',
      value: routeName.toUpperCase(),
      edit: false,
    };
    this.labelsRouter = [label];

    this.labelsTravelHistory[1] = label;
  }

  private async validateAndAssignButtonType(
    checkpointIndex: number
  ): Promise<void> {
    this.message.openLoading('Cargando', 'Validando puntos de control');
    await this.validateControlPointersComplete(checkpointIndex, false, true);
    this.checkpointService.assignButtonTypeToLastComplete(this.controlPointer);
    this.message.closeLoading();
  }
}
